export const PDF_SUMMARY_HEADING = "Give summary of this text, with few points-wise and paragraphs...   ";
